import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import {
  QueryContentMode,
  QueryTarget,
  SubmitStructuredQueryRequest,
} from "@/shared/domain/query";
import { SearchQueryBody, SimpleCondition } from "@/types";

export function useDeviceFiles(deviceId: string, orgId: string | undefined) {
  const { queryService } = useDomainServices();

  return useQuery({
    queryKey: ["deviceFiles", deviceId, orgId],
    queryFn: async () => {
      if (deviceId === undefined || orgId === undefined) {
        return Promise.reject(new Error("Invalid deviceId or orgId"));
      }

      // Create a condition to filter datasets by device_id
      const deviceCondition: SimpleCondition = {
        field: "device_id",
        comparator: "EQUALS",
        value: deviceId,
      };

      const searchQuery: SearchQueryBody = {
        condition: deviceCondition,
        sort_by: "created",
        sort_direction: "DESC",
      };

      const request: SubmitStructuredQueryRequest = {
        query: searchQuery,
        target: QueryTarget.Files,
        content_mode: QueryContentMode.RecordWithMeta,
      };

      const queryRecord = await queryService.submitStructured(request, {
        resourceOwnerId: orgId,
      });

      return queryRecord.query_id;
    },
    staleTime: 60000,
    enabled: deviceId !== undefined && orgId !== undefined,
  });
}
